<template>
  <div class="device-bd" v-if="funcView.device_tab_renting || funcView.device_tab_expire || funcView.device_tab_cancelled || funcView.device_tab_stock||funcView.device_tab_pending   || funcView.device_tab_buy">
    <div class="tab-box">
      <el-form :inline="true" @submit.native.prevent class="form-screen">
        <el-tabs v-model="statusState" style="float: left" v-if="funcView.device_tab_renting || funcView.device_tab_expire || funcView.device_tab_cancelled || funcView.device_tab_stock ||funcView.device_tab_pending  || funcView.device_tab_buy">
          <el-tab-pane :label="$t('device_zai_zu')" name="inventory" v-if="funcView.device_tab_renting" ></el-tab-pane>
          <el-tab-pane :label="$t('device_zai_ku')" name="stock" v-if="funcView.device_tab_stock"></el-tab-pane>
          <el-tab-pane :label="$t('device_dai_ru_ku')" name="pending" v-if="funcView.device_tab_pending &&isJv"></el-tab-pane>
          <el-tab-pane :label="$t('device_yi_gou_ji')" name="buy" v-if="funcView.device_tab_buy"></el-tab-pane>
          <el-tab-pane :label="$t('device_jiang_dao_qi')" name="expire" v-if="funcView.device_tab_expire"></el-tab-pane>
          <el-tab-pane :label="$t('device_yi_tui_zu')" name="surrender" v-if="funcView.device_tab_cancelled"></el-tab-pane>
        </el-tabs>
        <el-form-item
          style="float: right; margin-right: 0"
          v-if="(funcView.device_export_inventory||funcView.device_export_stock||funcView.device_export_buy||funcView.device_export_expire ||funcView.device_export_pending ) && statusState !== 'surrender'"
        >
          <el-button
            type="info"
            @click="onExport"
          >
            <i class="icon icon-export-excel"></i>
            {{ $t('com_export') }} Excel
          </el-button>
        </el-form-item>
        <el-form-item style="float: right" v-if="statusState==='expire'">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right" :style="{ 'margin-right': !(funcView.device_export_inventory||funcView.device_export_stock||funcView.device_export_buy||funcView.device_export_expire||funcView.device_export_pending) || statusState === 'surrender' ? '0' : '' }">
            <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
          </el-form-item>
          <el-form-item style="float: right">
            <!--  -->
            <search-input
              v-model="search"
              :placeholder="$t('device_jshsbmc')"
              @fetch="onRefs"
            ></search-input>
          </el-form-item>
      </el-form>
    </div>
    <!-- 在租 -->
    <device-rent v-if="statusState == 'inventory'" :isFilter="isFilter" :value="search" ref="deviceTable"> </device-rent>
    <!-- 在库 -->
    <device-stock v-if="statusState == 'stock'" :isFilter="isFilter" :value="search" ref="deviceTable"></device-stock>
    <!-- 待入库 -->
    <device-pending v-if="statusState == 'pending'" :isFilter="isFilter" :value="search" ref="deviceTable"></device-pending>
    <!-- 已购机 -->
    <device-buy v-if="statusState == 'buy'" :isFilter="isFilter" :value="search" ref="deviceTable"></device-buy>
    <!-- 已退租 -->
    <device-return v-if="statusState == 'surrender' && funcView.device_tab_cancelled" :isFilter="isFilter" :value="search" ref="deviceTable"></device-return>
    <!-- 将到期 -->
    <device-expired v-if="statusState == 'expire' && funcView.device_tab_expire" :isFilter="isFilter" :value="search" ref="deviceTable"></device-expired>
  </div>
</template>

<script>
import deviceRent from './children/device_rent.vue';
import deviceBuy from './children/device_buy.vue';
import deviceStock from './children/device_stock.vue';
import devicePending from './children/device_pending.vue';
import deviceExpired from './children/device_expired.vue';
import deviceReturn from './children/device_return.vue';

// device_zai_zu: 在租// device_zai_ku: 在库// device_dai_ru_ku: 待入库// device_yi_gou_ji: 已购机// device_jiang_dao_qi: 将到期// device_yi_tui_zu: 已退租// device_jshsbmc: 机身号/设备名称

export default {
  name: 'device',
  components: {
    deviceBuy,
    deviceRent,
    deviceStock,
    devicePending,
    deviceExpired,
    deviceReturn,
  },
  data() {
    return {
      statusState: '',
      isFilter: false,
      search: '',
    };
  },
  computed: {
    // 登录用户信息
    userInfo() {
      return this.$store.state.userInfo;
    },
    // (PF-平台，HQ-总部，SC-售后公司)，CO-大客户，JV-代理，CS-客户
    isJv() {
      return this.$store.state.userInfo && this.$store.state.userInfo.bizType === 'JV';
    },

  },
  watch: {
    $route: function () {
      if (this.getJump('status')) {
        this.statusState = this.getJump('status');
      }
    },
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_device');},
  methods: {
    i18nCallback() {
      this.getFuncView(null, () => {
        if (this.funcView.device_tab_renting) {
          this.statusState = this.getJump('status') || 'inventory';
        } else if (this.funcView.device_tab_expire) {
          this.statusState = this.getJump('status') || 'expire';
        } else if (this.funcView.device_tab_cancelled) {
          this.statusState = this.getJump('status') || 'surrender';
        } else if (this.funcView.device_tab_stock) {
          this.statusState = this.getJump('status') || 'stock';
        } else if (this.funcView.device_tab_pending) {
          this.statusState = this.getJump('pending') || 'pending';
        } else if (this.funcView.device_tab_buy) {
          this.statusState = this.getJump('status') || 'buy';
        }
      });
    },
    onRefs() {
      this.$refs.deviceTable.onPageChange({ page: 1 });
    },
    onExport() {
      this.$refs.deviceTable.onExport({ page: 1 });
    }
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.device-bd {
  padding: 24px;
  .tab-box {
    .form-screen {
      overflow: hidden;
      height: 40px;
      line-height: 40px;
    }
    .icon-filter {
      display: inline-block;
      text-align: center;
      box-sizing: border-box;
      font-size: 14px;
      width: 40px;
      height: 40px;
      color: $--color-text-primary;
      box-shadow: 0 0 0 1.5px #202945 inset;
      border-radius: 50px;
      cursor: pointer;
    }
  }
  .query-filter{
    margin-top: 24px;
  }
  .table-content {
    border-radius: 16px;
    background: #fff;
    margin-top: 24px;
    > .header {
      padding: 24px;
      .form-screen {
        display: flex;
        height: 40px;
        .el-form-item {
          margin-bottom: 0;
          align-self: center;
        }
        .label {
          color: #1a1a1a;
          line-height: 40px;
          font-weight: bold;
          float: left;
        }
        .status-type {
          align-self: center;
          ul {
            display: flex;
            li {
              height: 32px;
              line-height: 32px;
              border-radius: 47px;
              border: 1px solid #efefef;
              margin-right: 8px;
              padding: 0 12px;
              font-size: 0;
              display: flex;
              align-items: center;
              cursor: pointer;
              &.active {
                background: $--color-primary;
                p {
                  color: #fff;
                  font-family: PingFangSC-Semibold, PingFang SC;
                  span {
                    color: #fff;
                    font-family: PingFangSC-Regular, PingFang SC;
                  }
                }
                .point {
                  //  border: none;
                  background-color: #fff !important;
                }
              }
              p {
                margin-left: 8px;
                font-size: 12px;
                color: #333333;
                line-height: 32px;
                font-size: 12px;
                font-weight: bold;
                color: $--color-text-regular;
                line-height: 18px;
                span {
                  font-size: 12px;
                  margin-left: 4px;

                  color: $--color-text-secondary;
                  line-height: 18px;
                }
              }
              .point {
                width: 10px;
                height: 10px;
                display: inline-block;
                background: $--color-primary;
                // border: 3px solid #e5e5e5;
                border-radius: 50%;

                &.danger {
                  background: $--color-danger;
                }

                &.warning {
                  background: $--color-warning;
                }
                &.success {
                  background: $--color-success;
                }
                &.info {
                  background: $--color-info;
                }
              }
            }
          }
        }

        .search-content {
          float: right;
        }
      }
    }

    .table-bd {
      height: 562px;
      width: 100%;
      overflow: hidden;
      padding: 0 24px;
      // padding-top: 24px;
      .device-list {
        display: flex;
        flex-flow: row wrap;
        // justify-content: space-between;
        height: 572px;
        // height: 100%;
        align-content: flex-start;
        margin-top: -10px;
        overflow-y: auto;
        .li {
          margin-top: 10px;
          margin-right: 10px;
          width: calc(33.3% - 10px);
          flex: 0 0 calc(33.3% - 10px);
          height: 108px;
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #f4f4f4;

          padding: 16px;
          cursor: pointer;
          overflow: hidden;
          // align-items: center;
          // justify-content: center;
          &:hover {
            border-color: $--color-primary;
          }
          &:nth-child(3n + 3) {
            margin-right: 0;
          }
          .item {
            display: flex;
            position: relative;
            .img-box {
              width: 46px;
              height: 46px;
              flex: 0 0 46px;
              img {
                max-width: 100%;
                max-height: 100%;
              }
              &.gray {
                background: #f5f5f5;
              }
              &.offline {
                /** 图片去色 */
                -webkit-filter: grayscale(100%);
                -moz-filter: grayscale(100%);
                -ms-filter: grayscale(100%);
                -o-filter: grayscale(100%);
                filter: grayscale(100%);
                filter: gray;
              }
            }
            .info {
              flex: 1;
              margin-left: 16px;
              h3 {
                height: 20px;
                font-size: 16px;
                font-weight: bold;
                color: $--color-text-regular;
                line-height: 20px;
              }
              p {
                padding: 8px 0 12px 6px;
                display: flex;
                overflow: hidden; //超出隐藏
                span {
                  padding: 0 6px;
                  margin-right: 8px;
                  height: 18px;
                  background: #f4f4f4;
                  border-radius: 100px;
                  line-height: 18px;
                  font-size: 12px;
                  white-space: nowrap; //不换行
                  overflow: hidden; //超出隐藏
                  text-overflow: ellipsis; //变成...
                }
              }
              .state {
                display: flex;
                // height: 22px;
                // line-height: 22px;

                .device-status-container {
                  // text-align: center;
                  font-size: 0;
                  // width: 140px;
                  margin-right: 26px;
                  .device-status {
                    font-size: 12px;
                    color: #4d4d4d;
                    // margin-top: 24px;
                    overflow: hidden;
                    display: inline-block;

                    > li {
                      float: left;
                      height: 22px;
                      &:nth-child(n + 2) {
                        margin-left: 10px;
                      }
                      &.signal {
                        .val {
                          padding-left: 2px;
                        }
                      }
                      .key {
                        float: left;
                        color: #00a0d9;
                        .icon {
                          float: left;
                          font-size: 18px;
                          line-height: 22px;
                        }
                      }
                      .val {
                        float: left;
                        margin-left: 2px;
                        line-height: 22px;
                      }

                      .icon-wifi-i,
                      .icon-signal-i {
                        float: left;
                        // display: inline-block;
                        height: 18px;
                        width: 18px;
                        margin-top: 2px;
                        line-height: 22px;
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: 100%;
                      }
                      .signal-xinhao100 {
                        background-image: url('~@/images/layout/icon-signal-100.svg');
                      }
                      .signal-xinhao75 {
                        background-image: url('~@/images/layout/icon-signal-75.svg');
                      }
                      .signal-xinhao50 {
                        background-image: url('~@/images/layout/icon-signal-50.svg');
                      }
                      .signal-xinhao25 {
                        background-image: url('~@/images/layout/icon-signal-25.svg');
                      }
                      .wifi100 {
                        background-image: url('~@/images/layout/icon-wifi-100.svg');
                      }
                      .wifi66 {
                        background-image: url('~@/images/layout/icon-wifi-66.svg');
                      }
                      .wifi33 {
                        background-image: url('~@/images/layout/icon-wifi-33.svg');
                      }
                    }
                  }
                }
                .device-state {
                  // position: absolute;
                  // top: 16px;
                  // right: -8px;

                  .device-state-tag {
                    $r: 22px;
                    // width: $r;
                    // height: $r;
                    border-radius: $r / 2;
                    // background: rgba(13, 154, 224, 0.05);
                    overflow: hidden;
                    float: left;
                    &.has-name {
                      // width: auto;
                      // padding-right: 10px;
                      line-height: $r;
                      .icon {
                        // margin-left: 9px;

                        &.icon-cleaning,
                        &.icon-free {
                          font-size: 18px;
                        }

                        &.icon-cleaning {
                          margin-top: 5px;
                        }
                        &.icon-suspend,
                        &.icon-free,
                        &.icon-charge {
                          margin-top: 4px;
                        }

                        &.icon-machine-offline {
                          margin-top: 5px;
                          font-size: 18px;
                        }
                      }
                    }
                    &:nth-child(n + 2) {
                      margin-left: 6px;
                    }

                    .icon {
                      $r: 18px;
                      width: $r;
                      height: $r;
                      text-align: center;
                      line-height: $r;
                      float: left;
                      margin-top: 3px;
                      margin-left: 3px;
                      font-size: 18px;

                      // &.icon-machine-offline,

                      &.blue {
                        color: $--color-primary;
                      }

                      &.red {
                        color: $--color-danger;
                      }
                      &.yellow {
                        color: $--color-warning;
                      }
                      &.gray {
                        color: $--color-info;
                      }
                      &.green {
                        color: $--color-success;
                      }
                    }

                    .state-name {
                      float: left;
                      font-size: 12px;
                      color: #495057;
                      margin-left: 3px;
                    }
                  }
                }
              }
            }
            .point {
              position: absolute;
              right: 0;
              top: 0;
              display: inline-block;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: $--color-info;
              &.idle {
                background-color: $--color-primary;
              }
              &.running {
                background-color: $--color-success;
              }
              &.charging {
                background-color: $--color-warning;
              }
              &.offline {
                background-color: $--color-info;
              }
            }
          }
        }
      }
      .no-data {
        font-size: 16px;
        line-height: 140%;
        color: #818181;

        width: 100%;
        display: flex;
        height: 496px;
        justify-content: center;

        align-items: center;
        background-color: #fff;
      }
    }

    .page-footer {
      height: 88px;
    }
  }

  .map-container {
    height: 574px;
    padding: 0 24px 24px;
    & > div {
      border: 1px solid #00a0d9;
      border-radius: 16px;
    }
  }
}
</style>
